
/* injects from baggage-loader */

'use strict';

import AlertController from '../alert/alert.controller';

import { answers, successText, failText } from './quiz-tamandua.const';

import { chain, filter } from 'lodash';

export default class DialogQuizTamanduaController extends AlertController{
    constructor($log, $rootScope, $timeout, Dialog) {
        'ngInject';
        super($log, $rootScope);
        
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        
        this.answers = [];

        /*
        {
                type: 'a3',
                value: null,
                error: false,
                text: "Quantos passos o tamanduá <b>andou</b>?"   
            }
            */
    }

    $onInit(){
        this.answers = chain(answers)
            .shuffle()
            .take(2)
            .value();

        this.answers.push({
            type: 'total',
            value: null,
            error: false,
            text: "... andou <b>no total</b>?"
        });
    }
    

    validate(){
        angular.forEach(this.answers, a => {
            a.error = parseInt(a.value) !== this.getResponseValue(a.type);
        });

        this.$log.log(this.answers);

        return filter(this.answers, { error: true }).length ? false : true;
    }

    getResponseValue(type){
        let { player } = this.resolve.model;

        this.$log.log(player, type);

        switch (type) {
            case 'top':
                return player.events.top        
            case 'bottom':
                return player.events.bottom
            case 'left':
                return player.events.left     
            case 'right':
                return player.events.right
            case 'total':
                return this.getTotalSteps()
            default:
                break;
        }
    }

    onSubmit(form) {
        if (form.$invalid) return;
        return this.validate() ? this.onValidateSuccess() : this.Dialog.showAlert('label-opa', failText);
    }

    onValidateSuccess(){
        this.Dialog.showFeedback('label-very-good', successText, 'btn-continue', () => {
            this.$timeout(this.ok.bind(this), 200);
        });
    }

    getTotalSteps(){
        let totalEvents = 0;

        if (!this.resolve.model.player) return totalEvents;

        angular.forEach(this.resolve.model.player.events, position => {
            totalEvents += position;
        });

        return totalEvents;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-tamandua/quiz-tamandua.controller.js